export const PATH_USER_AVAIALBLE = `/api/v2/useravailable`;
export const PATH_EDIT_PROFILE = `/api/v2/user`;
export const PATH_EDIT_SEND_WHATSAPP_ALERT = `/api/v2/userWhatsapp/alert`;
export const PATH_EDIT_SEND_WHATSAPP_OPPORTUNITY = `/api/v2/userWhatsapp/opportunity`;
export const PATH_CHANGE_PASSWORD = `/api/v2/userme/changepass`;
export const PATH_USERS = `/api/v2/user`;
